module.exports = __webpack_public_path__ + "ca49bd3be1a2b73730e2f4e12490c777.png";